// 单规格订单详情
export default {
    heard_title: "Item Order Details",
    heard_btn: "Return",

    order_title: "Submit order",
    opt_close: "Close order",
    opt_memo: "Order Memo",

    // 单规格项目信息
    th_itemInfo: "Item Info",
    tl_space_proj: "Site/Project Name",
    tl_proj: "Project Name",
    tl_spec_player: "Model/Player",
    tl_kartName: "KartName",
    tl_price: "Price",
    tl_scheduleTime: "Date",
    tl_TicketNum: "Number",
    tl_group: "group",
    tl_player: "player",
    tl_scheduleCode: "Schedule",
    tl_quantity: "Quantity",
    tl_amount: "Subtotal",
    tl_status: "Status",
    tb_cancel: "Cancel",
    tb_refund: "Refund",
    tl_total: "Total:",

    // 多规格项目信息
    tl_scheduleDate: "Date",
    tl_timeSection: "Time",

    // 备注弹出框
    dt_memoOrder: "Memo Order",
    dt_closeOrder: "Close order",
    dp_memo: "Please enter a remark",

    // 退款弹出框
    dt_refund: "Refund",
    fl_reason: "Reason for refund",
    fp_reason: "refund reason",
    fl_refundNum: "Number of refunds",
    fl_refundOrderAmount: "Order Amount",
    fl_refundAmount: "Confirm refund amount",
    fl_refundDesc: "Refund Description",

    // 核销弹出框
    dt_cancel: "Cancel",
    dl_tip: "Are you sure to write off?",
    fl_cancelNum: "Quantity written off:",

    // 相关提示
    sm_refund: "Refund Success",
    em_refund: "Refund Error",
    sm_cancel: "Successful write-off",
    em_cancel: "Cancellation failed",
    em_cancelMin: "The minimum write-off quantity is 1",
    em_cancelMax: "The number of write-offs has reached the maximum value",
    em_refundReason: "Please select a refund reason",
    em_refundNum: "The refund amount is greater than the order amount",
    em_refundMin: "The minimum refund amount is 1",
    em_refundMax: "Refundable amount has reached the maximum",
    sm_closeOrder: "Close the order successfully",
    sm_updateMemo: "Remark order success",

    // 过滤器
    // projStatusFilter
    ft_notPaid: "to be paid",
    ft_notConsumed: "To be written off",
    ft_consumption: "cancelled",
    ft_completed: "completed",
    ft_expired: "expired",
    ft_deleted: "deleted",
    ft_refund: "refunded",
    ft_changedl: "has been changed",

    // stepStatusFilter
    ft_create: "Create order",
    ft_update: "update order",
    ft_payment: "payment order",
    ft_confirm: "confirm order",
    ft_cancel: "cancel order",
    ft_close: "Close order",
    ft_complete: "Complete an order",
    ft_apply_after_sale: "Apply for after sales",
    ft_complete_after_sale: "Complete after-sale",
    ft_delete: "Delete order",

    // payStatusFilter
    ft_not_paid: "unpaid ",
    ft_paid: " paid ",
    ft_pay: " in payment "
};
